export default __webpack_public_path__ + "static/media/pollard.dfaa1dee.png";